<div class="flex flex-column xl:flex-row lg:flex-row gap-2 lg:gap-0 xl:gap-0 justify-content-end mb-4">
    <p-button (click)="openDetails($event,'description')" label="view description" [rounded]="true"
        class="flex primary-background primary white-space-nowrap send-message-color">
        
    </p-button>
    <p-button (click)="openDetails($event,'requirements')" label="view requirements" [rounded]="true"
        class="ml-0 xl:ml-3 lg:ml-3 flex primary-background primary white-space-nowrap send-message-color">
        
    </p-button>
    <p-button
        (click)="openDetails($event,'responsibilities')"  label="view responsibilities"
        [rounded]="true"
        class="ml-0 xl:ml-3 lg:ml-3 flex primary-background primary white-space-nowrap send-message-color">
        
    </p-button>
</div>

<div class="grid grid-nogutter wrap-doc-details">
    <div class="py-0 pr-4 pl-0 col-12 md:col-12 sm:col-12">
        <span class="text-base block font-medium mt-3">Location</span>
    </div>
    <div *ngIf="!jobDetails?.isRemote">
        <div class="py-0 pr-4 pl-0 col-2 md:col-2 sm:col-2">
            <span class="text-primary mt-2 block text-xs">City</span>
            <p class="m-0 text-black-alpha-60 font-medium text-sm">
                {{jobDetails.city}}
            </p>
        </div>
        <div class="py-0 pr-4 pl-0 col-2 md:col-2 sm:col-2">
            <span class="text-primary mt-2 block text-xs">State</span>
            <p class="m-0 text-black-alpha-60 font-medium text-sm">
                {{jobDetails.country || jobDetails.state}}
            </p>
        </div>
        <div class="py-0 pr-4 pl-0 col-2 md:col-2 sm:col-2">
            <span class="text-primary mt-2 block text-xs">Zip</span>
            <p class="m-0 text-black-alpha-60 font-medium text-sm">
                {{jobDetails.postalCode}}
            </p>
        </div>
    </div>
    <p *ngIf="jobDetails?.isRemote" class="m-0 text-black-alpha-60 font-medium text-sm">
        Remote
    </p>   
    <div class="py-0 pr-4 pl-0 col-12 md:col-12 sm:col-12">
       <span class="text-base block font-medium mt-3">{{'Screening Questions'}}</span>
    </div>
    <div *ngIf="jobDetails?.conflictQuestions?.length" class="p-datatable-striped col-12 p-0">
        <p-table styleClass="p-datatable-sm p-datatable-sm--normal" [value]="jobDetails.conflictQuestions" class="col-12">
            <ng-template pTemplate="header">
                <tr class="table-data">
                <th> 
                    Questions
                </th>
                <th class="td-center">
                    Answers
                </th>
            </tr>
            </ng-template>
            <ng-template pTemplate="body" let-question>
                <tr class="table-data surface-100">
                    <td>
                        <div class="inner-wrap p-0">
                            {{ question.title }}
                        </div>
                    </td>
                    <td class="td-center">
                        {{ question?.answer? 'Yes': 'No' }}
                    </td>
                </tr>
            </ng-template>
        </p-table>
    </div>
    <p *ngIf="!jobDetails?.conflictQuestions?.length" class="m-0 text-black-alpha-60 font-medium text-sm">
        No screening questions
    </p>
</div>
<p-dialog 
    [header]="modalHeader" 
    [(visible)]="visible" 
    [style]="{width: '50vw', maxHeight: '80vh'}" 
    draggable="false" 
    [resizable]="false" 
    [modal]="true"  
    [breakpoints]="{ '1199px': '75vw', '767px': '90vw' }"
    styleClass="html-content-dialog">
    
    <!-- Enhanced HTML content rendering -->
    <div class="html-content-container" [ngClass]="{'dark-theme': isDarkTheme}">
        <div 
            class="html-content-wrapper"
            [innerHTML]="sanitizedModalContent"
            *ngIf="modalContent; else loadingTemplate">
        </div>
        
        <ng-template #loadingTemplate>
            <div class="loading-placeholder">
                <i class="pi pi-spin pi-spinner"></i>
                <span>Loading content...</span>
            </div>
        </ng-template>
    </div>
    
    <!-- Optional: Action buttons in dialog footer -->
    <ng-template pTemplate="footer">
        <div class="flex justify-content-end gap-2">
            <p-button 
                label="close" 
                (click)="closeDialog()" 
                [outlined]="true" 
                size="small">
            </p-button>
        </div>
    </ng-template>
</p-dialog>